import React from "react";
import { color, typography } from "../../shared/style";
import styled from "styled-components";
import { Link } from "../../components/Link/Link";
import { Text } from "../../components/Text/Text";
const CourseItem = ({ item }) => {
  const redirectPage = (url) => {
    window.location.href = `/course/${url}`;
  };
  if (!item) return null;
  return (
    <Wraper>
      <WrapperContent>
        <WrapImage>
          <Image
            src={item?.data?.owner?.document?.data?.logo?.url}
            alt={item?.data?.owner?.document?.data?.logo?.alt}
          ></Image>
        </WrapImage>
        <Content>
          <WrapBodyItem>
            <Title
              tag="h5"
              capital="uppercase"
              font="Alternate Gothic No1 D"
              weight={typography.weight.regular1}
              color={color.primary.blue}
              lineHeight={36}
              size={typography.size.l1}
            >
              {item?.data?.banner_title.text}
            </Title>

            <Description
              tag="p"
              weight={typography.weight.regular}
              color={color.netraul.black100}
              font="Oxygen"
              lineHeight={26}
            >
              {item?.data?.banner_description?.text}
            </Description>
          </WrapBodyItem>
          <WrapFooterItem>
            <Btn
              onClick={() => redirectPage(item?.uid)}
              size={typography.size.s3}
              color={color.primary.blue}
            >
              Learn more and enroll
            </Btn>
            <Date
              font={typography.type.primary}
              size={typography.size.s2}
              color={color.netraul.black50}
              lineHeight={22}
            >
              {item?.data?.body[0]?.primary?.start_date} -{" "}
              {item?.data?.body[0]?.primary?.end_date}
            </Date>
          </WrapFooterItem>
        </Content>
      </WrapperContent>
    </Wraper>
  );
};

const WrapBodyItem = styled.div``;
const WrapFooterItem = styled.div``;
const Wraper = styled.div`
  flex: 0 0 33.333%;
  max-width: 33.333%;
  padding: 0 17px;
  box-sizing: border-box;
  margin-bottom: 34px;

  @media (max-width: 992px) {
    flex: 0 0 50%;
    max-width: 50%;
    padding: 0 20px;
  }
  @media (min-width: 400px) and (max-width: 650px) {
    min-height: auto;
    flex: 0 0 100%;
    max-width: 100%;
    padding: 0 20px;
    margin-bottom: 20px;
  }
  @media (max-width: 400px) {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 0 20px;
    margin-bottom: 20px;
  }
`;

const WrapperContent = styled.div`
  background-color: ${color.primary.white};
  padding: 29px 30px 28px 30px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  cursor: pointer;
  flex-direction: column;
  :hover {
    transition: filter 0.2s ease-in-out;
    filter: drop-shadow(0px 18px 25px rgba(0, 0, 0, 0.12));
    div {
      span:first-child {
        color: #3dae73;
      }
    }
  }
  @media (max-width: 650px) {
    padding: 20px;
    height: auto;
  }
`;

const WrapImage = styled.div`
  max-width: 110px;
  box-sizing: border-box;
  margin-bottom: 23px;
`;
const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;
const Title = styled(Text)`
  cursor: pointer;
`;
const Description = styled(Text)`
  margin-top: 20px;
`;

const Btn = styled(Link)`
  display: inline-block;
  font-weight: bold;
  border-bottom: 1px solid ${color.primary.blue};
  margin-top: 20px;
`;

const Date = styled(Text)`
  display: block;
  margin-top: 23px;
`;

export default CourseItem;
